import { DataDeliveryDestination } from '@shared/models/data-delivery-destination.model';
import { StageHistory } from '@shared/models/data-delivery-stage-history.model';

export const DataDeliveryDeliveryStatuses = ['ScheduleFired', 'MappedOutput', 'Sent'] as const;

type DataDeliveryDeliveryStatusTuple = typeof DataDeliveryDeliveryStatuses;
export type DataDeliveryDeliveryStatus = DataDeliveryDeliveryStatusTuple[number];

export const DataDeliveryDeliveryStatusMap: Record<DataDeliveryDeliveryStatus, string> = {
  ScheduleFired: 'Schedule Fired',
  MappedOutput: 'Mapped Output',
  Sent: 'Sent',
} as const;

export const DataDeliveryDeliveryStatusColorMap: Record<DataDeliveryDeliveryStatus, 'success' | 'info'> = {
  ScheduleFired: 'info',
  MappedOutput: 'info',
  Sent: 'success',
} as const;

export type DataDeliveryDelivery = {
  data_delivery_route_id: string;
  destination?: DataDeliveryDestination;
  created: string;
  partner: string;
  stage_history: StageHistory[];
  errors?: string[];
  schedule_execution: string;
  filenames: string[];
  date_range: string[];
  ra_entity_npi?: string;
  ra_entity_name?: string;
  status: DataDeliveryDeliveryStatus;
  is_835?: number;
};

export type DataDeliveryDeliveryExtended = DataDeliveryDelivery & {
  statusColor: string;
};
